module.exports = __webpack_public_path__ + "img/menu-icon.55f68494.svg";